import React, { useState, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { Spin, Calendar, Empty } from 'antd';
import moment from 'moment';
import { BiCalendar } from 'react-icons/bi';
import CalendarHeader from '../CalendarHeader/CalendarHeader';
import BlockHeader from '../BlockHeader/BlockHeader';
import { queryKeys } from '../../../../queries/queryKeys';
import { sortByDate } from '../../../../helpers/sortFns';
import { selectedRequestSelector } from '../../../../reducers/acceptanceRequestToCalendarReducer';
import styles from './CalendarBlock.module.scss';

const CalendarBlock = ({ selectedDate, onChange }) => {
  const [validRange, setValidRange] = useState(undefined);

  const queryClient = useQueryClient();
  const request = useSelector(selectedRequestSelector);
  const daysState = queryClient.getQueryState(
    queryKeys.requestInvitationDays(request?.id)
  );

  const handleChange = (date) => {
    let newDate = date;
    const dateString = newDate.format('YYYY-MM-DD');
    const days = daysState?.data;

    if (!days?.includes(dateString)) {
      let closestDate;
      let minDifference = Infinity;

      for (let i = 0; i < days.length; i++) {
        const availableDate = moment(days[i]);
        const difference = Math.abs(availableDate - newDate);

        if (difference < minDifference) {
          minDifference = difference;
          closestDate = availableDate;
        }
      }
      newDate = closestDate;
    }

    onChange(newDate);
  };

  useEffect(() => {
    let validRange;
    const days = daysState?.data;

    if (days?.length) {
      const sortedDays = sortByDate(days, 'asc');
      const start = moment(sortedDays[0]);
      const end = moment(sortedDays[sortedDays.length - 1]);

      validRange = [start, end];
    }

    setValidRange(validRange);
  }, [daysState?.data]);

  return (
    <Spin spinning={daysState?.isFetching || false}>
      {selectedDate ? (
        <Calendar
          className={styles.root}
          fullscreen={false}
          onChange={handleChange}
          value={selectedDate}
          disabledDate={(currentDate) => {
            const days = daysState?.data;
            const dateString = currentDate.format('YYYY-MM-DD');
            return !days?.includes(dateString);
          }}
          validRange={validRange}
          headerRender={({ value, onChange }) => (
            <CalendarHeader
              selectedDate={value}
              onDateChange={onChange}
              validRange={validRange}
            />
          )}
        />
      ) : (
        <>
          <BlockHeader
            as="header"
            icon={<BiCalendar />}
            title="Выбрать дату"
            description="Дата не выбрана"
          />
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Нет дат с назначенной приемкой"
          />
        </>
      )}
    </Spin>
  );
};

export default CalendarBlock;
